import { appInsights } from './appInsightsService';
import store from '../store/index';


function getBrowserType() {
  const { userAgent } = navigator;
  let browserName = '';

  if (userAgent.match(/chrome|chromium|crios/i) && !userAgent.match(/edg/i)) {
    browserName = 'chrome';
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = 'firefox';
  } else if (userAgent.match(/safari/i) && !userAgent.match(/edg/i)) {
    browserName = 'safari';
  } else if (userAgent.match(/opr\//i)) {
    browserName = 'opera';
  } else if (userAgent.match(/edg/i)) {
    browserName = 'edge';
  }
  return browserName;
}

function getCustomProperties(screenname, action, metadata) {
  const loggedInUser = store.getters["login/getUser"];

  const user = store.getters["login/getIsUserAuthenticated"] ? loggedInUser : { email: '', role: '' };

  const customProperties = {
    UserEmail: user.email,
    UserRole: user.isSuperAdmin ? 'Super Admin' : user.hasAdminRights ? 'Admin'  : 'User',
    ApplicationName: 'FormIO',
    Browser: getBrowserType(),
    ScreenResolution: `${window.screen.width} X ${window.screen.height}`,
    TriggeredOn: new Date().toUTCString(),
    Screen: screenname,
    UserAction: action,
    ActionMetaData: metadata
  };
  return customProperties;
}

const logCustomEvent = (screenname, action, metadata = null) => {
  const message = `FormIO-${screenname}-${action}-Triggered`;
  appInsights.trackEvent({ name: message, properties: getCustomProperties(screenname, action, metadata) });
};

const logException = (action, error, metadata = null) => {
  appInsights.trackException({ exception: new Error(JSON.stringify(error)), properties: getCustomProperties('', action, metadata) });
};

export {
  logException,
  logCustomEvent
};
